import template from './datepicker.html'

const MONTH_NAMES = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
//const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const MONTH_SHORT_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
//const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const datepickerComponent = (options) => {
    return {
        MONTH_NAMES,
        MONTH_SHORT_NAMES,
        DAYS,
        field: null,
        showDatepicker: false,
        format: options.format ? options.format : 'YYYY-MM-DD',
        showTime: false,
        month: "",
        year: "",
        hours: "",
        minutes: "",
        seconds: "",
        no_of_days: [],
        blankdays: [],
        value: '',
        v: {},
        async init() {
            const today = dayjs()
            this.field = today.format(this.format)
            options.setDate(this.field)
            //if (v) this.v = v
            this.month = today.month()
            this.year = today.year()
            this.hours = "00"
            this.minutes = "00"
            this.seconds = "00"
            this.getNoOfDays()
            this.$nextTick(() => {
                this.$el.innerHTML = template
            })
        },
        wrap: {
            ['x-on:click']() {
                this.show()
            },
            ['x-on:keydown.escape']() {
                this.showDatepicker = false
            }
        },
        isSelectedDate(date) {
            const d = dayjs(`${this.year}-${this.month+1}-${date}`)
            return this.field ===
                d.format(this.format) ?
                true :
                false;
        },
        isToday(date) {
            const today = dayjs();
            const d = dayjs(`${this.year}-${this.month+1}-${date}`)
            return today.format(this.format) === d.format(this.format) ?
                true :
                false;
        },
        getDateValue(date) {
            let selectedDate = dayjs(`${this.year}-${this.month+1}-${date}`)
            this.field = selectedDate.format(this.format)

            options.setDate(this.field)
            // this.$refs.date.value = selectedDate.getFullYear() + "-" + ('0' + formattedMonthInNumber).slice(-2) + "-" + ('0' + selectedDate.getDate()).slice(-2);
            this.isSelectedDate(date)
            this.showDatepicker = false
        },
        getNoOfDays() {
            let daysInMonth = dayjs(`${this.year}-${this.month+1}-01`).daysInMonth()
            // find where to start calendar day of week
            let dayOfWeek = dayjs(`${this.year}-${this.month+1}-01`).day()
            let blankdaysArray = [];
            for (var i = 1; i <= dayOfWeek; i++) {
                blankdaysArray.push(i);
            }
            let daysArray = [];
            for (var i = 1; i <= daysInMonth; i++) {
                daysArray.push(i);
            }
            this.blankdays = blankdaysArray;
            this.no_of_days = daysArray;
        },
        hoursUp() {
            let hours = parseInt(this.hours)
            hours++;
            if (hours>23) hours = 0
            this.hours = hours < 10 ? hours = "0" + hours : hours
        },
        hoursDown() {
            let hours = parseInt(this.hours)
            hours--;
            if (hours < 0) hours = 23
            this.hours = hours < 10 ? hours = "0" + hours : hours
        },
        minutesUp() {
            let minutes = parseInt(this.minutes)
            minutes+=5;
            if (minutes>55) minutes = 0
            this.minutes = minutes < 10 ? minutes = "0" + minutes : minutes
        },
        minutesDown() {
            let minutes = parseInt(this.minutes)
            minutes-=5;
            if (minutes < 0) minutes = 55
            this.minutes = minutes < 10 ? minutes = "0" + minutes : minutes
        },
        secondsUp() {
            let seconds = parseInt(this.seconds)
            seconds+=5;
            if (seconds>55) seconds = 0
            this.seconds = seconds < 10 ? seconds = "0" + seconds : seconds
        },
        secondsDown() {
            let seconds = parseInt(this.seconds)
            seconds-=5;
            if (seconds < 0) seconds = 55
            this.seconds = seconds < 10 ? seconds = "0" + seconds : seconds
        },
        show() {
            let today;
            const value = this.field
            if (value) {
                today = dayjs(value, this.format)
            } else {
                today = dayjs()
            }
            this.month = today.month()
            this.year = today.year()
            this.field = today.format(this.format)
            this.showDatepicker = !this.showDatepicker
            this.getNoOfDays()
        }
    }
}

export { datepickerComponent }
